<template>
  <div>
      <!--返回顶部-->
      <div class="backTop"><img src="static/img/footer/back.png" alt=""></div>
      <!--返回顶部-->
  </div>
</template>

<script>
    import store from '@/vuex/store';
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';
    import $ from 'jquery';
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
    export default {
        name: "BackTop",
        data(){
            return {

            }
        },
        mounted() {
            $(function(){
            //1.内容大于800px scroll--->scrollTop
            $(window).on('scroll',function(){
                var $scroll=$(this).scrollTop();
                if($scroll>=1000){
                    $('.backTop').show();
                }else{
                    $('.backTop').hide();
                }
            });
            //3.返回顶部
            $('.backTop').on('click',function(){
                $('html,body').animate({//$('html,body')
                    scrollTop:0
                })
            });
        }
            )}

    }
</script>

<style lang="less" scoped>
    .backTop{
        position: fixed;
        right: 0.3%;
        bottom: 15%;
        z-index: 10;
        width: 102px;
        height: 102px;
        cursor: pointer;
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/nav/BackTop.vue